// clocks
var canvas_newYork = document.getElementById("canvas_newYork");
var cty = canvas_newYork.getContext("2d");
var radius = canvas_newYork.height / 2;
cty.translate(radius, radius);
radius = radius * 0.90;

var canvas_london = document.getElementById("canvas_london");
var ctl = canvas_london.getContext("2d");
var radius = canvas_london.height / 2;
ctl.translate(radius, radius);
radius = radius * 0.90;

var canvas_san_francisco = document.getElementById("canvas_san_francisco");
var ctf = canvas_san_francisco.getContext("2d");
var radius = canvas_san_francisco.height / 2;
ctf.translate(radius, radius);
radius = radius * 0.90;

var canvas_bangalore = document.getElementById("canvas_bangalore");
var ctb = canvas_bangalore.getContext("2d");
var radius = canvas_bangalore.height / 2;
ctb.translate(radius, radius);
radius = radius * 0.90;

var canvas_tokyo = document.getElementById("canvas_tokyo");
var ctto = canvas_tokyo.getContext("2d");
var radius = canvas_tokyo.height / 2;
ctto.translate(radius, radius);
radius = radius * 0.90;

function drawFace(clock, radius) {
    var grad;
    clock.clearRect(radius - clock.lineWidth, radius - clock.lineWidth, radius * 2 + (clock.lineWidth*2), radius * 2 + (clock.lineWidth*2));
    clock.beginPath();
    clock.arc(0, 0, radius, 0, 2*Math.PI);
    clock.fillStyle = '#050915';
    clock.fill();
    // clock.strokeStyle ='#f2f2f2';
    // clock.lineWidth = radius*0.1;
    // clock.lineCap = "round";
    
    grad = clock.createRadialGradient(0,0,radius*0.95, 0,0,radius*1.05);
    grad.addColorStop(0, '#f2f2f2');
    clock.strokeStyle = grad;
    clock.lineWidth = radius*0.02;
    clock.stroke();
    clock.beginPath();
    
    clock.stroke();
    clock.closePath();
}

function drawNumbers(clock) {
    var ang;
    var num;
    clock.font = radius*0.15 + "px arial";
    clock.textBaseline="middle";
    clock.textAlign="center";
    for(num= 1; num < 13; num++){
        ang = num * Math.PI / 6;
        clock.rotate(ang);
        clock.translate(0, -radius*0.85);
        clock.rotate(-ang);
        clock.fillText(num.toString(), 0, 0);
        clock.rotate(ang);
        clock.translate(0, radius*0.85);
        clock.rotate(-ang);
    }
}

function drawHand(clock, pos, length, width) {
    clock.beginPath();
    clock.lineWidth = width;
    clock.lineCap = "round";
    clock.moveTo(0,0);
    clock.rotate(pos);
    clock.lineTo(0, -length);
    clock.stroke();
    clock.rotate(-pos);
}

function drawTime(clock, radius){
    var hour = 0;
    var minute = 0;
    var second = 0;
    var min_text = '';
    var hour_text = '';
    var text = '';
    
    if (clock.canvas.id === 'canvas_newYork'){
        var newYork = moment.tz("America/New_York");
        hour = newYork.hour();
        minute = newYork.minute();
        second = newYork.second();
    }
    else if (clock.canvas.id === 'canvas_london'){
        var london = moment.tz("Europe/London");
        hour = london.hour();
        minute = london.minute();
        second = london.second();
    }
    else if (clock.canvas.id === 'canvas_san_francisco'){
        var san = moment.tz("America/Los_Angeles");
        hour = san.hour();
        minute = san.minute();
        second = san.second();
    }
    else if (clock.canvas.id === 'canvas_bangalore'){
        var ban = moment.tz("Asia/Kolkata");
        hour = ban.hour();
        minute = ban.minute();
        second = ban.second();
    }
    else if (clock.canvas.id === 'canvas_tokyo'){
        var tok = moment.tz("Asia/Tokyo");
        hour = tok.hour();
        minute = tok.minute();
        second = tok.second();
    }
    
    text = document.getElementById("time_"+clock.canvas.id);
    hour_text = (hour < 10) ? ("0" + hour) : hour;
    min_text = (minute < 10) ? ("0" + minute) : minute;
    text.innerHTML = hour_text+':'+min_text;
    
    //hour
    hour=hour%12;
    hour=(hour*Math.PI/6)+(minute*Math.PI/(6*60))+(second*Math.PI/(360*60));
    drawHand(clock, hour, radius*0.5, radius*0.07);
    //minute
    minute=(minute*Math.PI/30)+(second*Math.PI/(30*60));
    drawHand(clock, minute, radius*0.8, radius*0.07);
    //  // second
    // second=(second*Math.PI/30);
    // drawHand(clock, second, radius*0.9, radius*0.02);
}
  
function drawClock() {
  drawFace(cty, radius);
  drawNumbers(cty, radius);
  drawTime(cty, radius);
  
  drawFace(ctl, radius);
  drawNumbers(ctl, radius);
  drawTime(ctl, radius);
  
  drawFace(ctf, radius);
  drawNumbers(ctf, radius);
  drawTime(ctf, radius);
  
  drawFace(ctb, radius);
  drawNumbers(ctb, radius);
  drawTime(ctb, radius);
  
  drawFace(ctto, radius);
  drawNumbers(ctto, radius);
  drawTime(ctto, radius);
}

setInterval(drawClock, 1000);